import React from "react";

/**
 * Binary pill toggle — replaces a 2-option <select>
 * Props:
 *   name     string              — field name
 *   value    string              — current selected value
 *   options  [{value, label}]    — exactly 2 options
 *   onChange fn                  — receives synthetic event { target: { name, value } }
 */
export default function PillToggle({ name, value, options, onChange }) {
  const handleClick = (optValue) => {
    onChange({ target: { name, value: optValue } });
  };

  return (
    <div className="pill-toggle">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`pill-toggle-btn${value === opt.value ? " active" : ""}`}
          onClick={() => handleClick(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
